<script>
  import {
    VImg
  } from 'vuetify/lib'
  export default {
    name: 'wh-img',
    extends: VImg
  };
</script>